(() => {
  const SELECTOR = '[data-showroom-availability]';

  const MESSAGE_ATTRS = {
    showroom_and_cubbo: 'messageShowroomAndCubbo',
    showroom_only: 'messageShowroomOnly',
    cubbo_only: 'messageCubboOnly',
    unavailable: 'messageUnavailable',
  };

  const fetchShowroomBadge = (rootUrl, variantId) => {
    let root = rootUrl || '/';
    if (!root.endsWith('/')) root += '/';

    return fetch(`${root}variants/${variantId}/?section_id=showroom-availability`)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        return section.querySelector('[data-showroom-badge]')?.outerHTML || '';
      });
  };

  const applyBlockMessage = (container) => {
    const badge = container.querySelector('[data-showroom-badge]');
    if (!badge) return;

    const attr = MESSAGE_ATTRS[badge.dataset.showroomState];
    const message = attr ? container.dataset[attr] : '';
    const textEl = badge.querySelector('[data-showroom-text]');
    if (message && textEl) textEl.textContent = message;
  };

  const updateShowroom = (variantId) => {
    const containers = document.querySelectorAll(SELECTOR);
    if (!containers.length || !variantId) return;

    const rootUrl = containers[0].dataset.rootUrl || window.Shopify?.routes?.root || '/';

    fetchShowroomBadge(rootUrl, variantId)
      .then((html) => {
        containers.forEach((container) => {
          container.innerHTML = html;
          applyBlockMessage(container);
          container.toggleAttribute('hidden', !html);
        });
      })
      .catch(() => {
        containers.forEach((container) => {
          container.innerHTML = '';
          container.setAttribute('hidden', '');
        });
      });
  };

  document.addEventListener('variant:changed', (event) => {
    const variantId = event.detail?.variant?.id;
    if (variantId) updateShowroom(variantId);
  });
})();
